<template>
  <div>
    <b-modal ref="modal"
              title="Google Calendar Sync Response"
              v-model="showCloseWindowModal"
              :header-bg-variant="modalHeaderColor"
              :header-text-variant="modalTextColor"
              :body-bg-variant="responseBackgroundColor"
              :body-text-variant="modalBodyTextColor"
              :footer-bg-variant="modalFooterColor"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close>
        <!-- Modal Content Section -->
        <div v-if="receivedResponse">
          <p> Status: {{googleCalendarSyncResponseStatus}}</p>
          <p> Message: {{googleCalendarSyncResponseMessage}}</p>
        </div>
        <div v-else>
          Waiting for Google Calendar Sync Response...
          <div class="loader"></div>
        </div>
        <!-- Modal Footer Section -->
        <div slot="modal-footer" v-if="receivedResponse">
          <b-btn size="sm" class="float-right" variant="primary" @click="closeWindow">
            Close Window
          </b-btn>
        </div>
        <div slot="modal-footer" v-else>
          <!-- This empty footer is here to prevent the Ok and Cancel buttons from rendering -->
        </div>
  </b-modal>
</div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'google-calendar-sync',
    props: ['streamUuid', 'currentSemester', 'currentYear'],
    components: {
    },
    data: () => {
      return {
        googleCalendarSyncResponseStatus: '',
        googleCalendarSyncResponseMessage: '',
        showCloseWindowModal: true,
        receivedResponse: false,
        modalHeaderColor: 'primary',
        modalTextColor: 'light',
        modalFooterColor: 'light'
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'loginToGoogleCalendar',
        'syncWithGoogleCalendar',
        'setGoogleCalendarSyncStatusMessage'
      ]),
      loadProps () {
        let streamUuid = (this.streamUuid) ? this.streamUuid : localStorage.getItem('streamUuid')
        let currentSemester = (this.currentSemester) ? this.currentSemester : localStorage.getItem('currentSemester')
        let currentYear = (this.currentYear) ? this.currentYear : localStorage.getItem('currentYear')
        let googleOAuthToken = this.$route.query.token

        return {streamUuid: streamUuid, currentSemester: currentSemester, currentYear: currentYear, googleOAuthToken: googleOAuthToken}
      },
      loadData () {
        let props = this.loadProps()

        if (!props.googleOAuthToken || props.googleOAuthToken === 'access_denied') {
          window.close()
        }

        this.syncWithGoogleCalendar({
          streamUuid: props.streamUuid,
          currentYear: props.currentYear,
          currentSemester: props.currentSemester,
          googleOAuthToken: props.googleOAuthToken
        }).then(res => {
          let message = ''
          let status = ''
          if (res) {
            message = 'Successfully synced ' + props.currentSemester + ' ' +
                props.currentYear + ' events'
            status = 'success'
          } else {
            message = 'There was a problem syncing ' + props.currentSemester + ' ' +
                props.currentYear + ' events'
            status = 'failure'
          }

          this.googleCalendarSyncResponseStatus = status
          this.googleCalendarSyncResponseMessage = message
          this.showCloseWindowModal = true
          this.receivedResponse = true
        })
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      onShown () {
      },
      closeWindow () {
        window.close()
      }
    },
    computed: {
      responseBackgroundColor () {
        let responseReceived = this.receivedResponse
        if (!responseReceived) {
          return 'light'
        }
        let status = this.googleCalendarSyncResponseStatus
        return status === 'success' ? 'success' : 'warning'
      },
      modalBodyTextColor () {
        let responseReceived = this.receivedResponse
        return !responseReceived ? 'dark' : 'light'
      }
    }
  }
</script>

<style scoped>
.conflict {
    color: red
}

.no-conflict {
    color: green
}

.loader {
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 2s linear infinite;
    float: right;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/app/semester/components/GoogleCalendarSync.vue